module.exports = __webpack_public_path__ + "img/top_bg1_p.dc6a21fe.png";